/*
 * HONEYWELL INC.,
 * COPYRIGHT (c) 2022
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */
import { IMessageDescriptor } from '@scuf/localization/dist/types';

export enum TimeInterval {
  Monthly,
  ThreeMonths,
  Yearly,
  Daily,
  Hourly
}

export interface IUrjanetMessageObjectType {
  [key: string]: IMessageDescriptor;
}

export type energyFields =
  | 'totalConsumption'
  | 'totalBaselineConsumption'
  | 'absoluteTotalConsumption'
  | 'absoluteTotalBaselineConsumption';

export type consumFields =
  | 'totalConsumption'
  | 'totalBaselineConsumption'
  | 'totalActualEmission'
  | 'totalPreviousPeriodEmission';

export type fuelTypes = 'Kerosene' | 'Gasoline' | 'Nitrous oxide';
